<!-- Schedule Ui -->
<!-- 
{{scheduleForm?.value | json}}
{{scheduleForm?.get(['date', 'end', 'value'])?.value | json}} -->
<div class="cards-wrapper flex-wrap gap-30 mt-18 " style="
 flex-wrap: wrap;
justify-content: flex-start; display: flex;
">
    <mat-card class="gon" style="box-sizing: border-box; width: 300px;
  position: sticky;
  top: 0px;
max-height: max-content;
height: 100%;

padding-bottom: 0px;
overflow-y: auto;
max-width: 100%;
">

        <mat-card-header class="p-12">
            <mat-card-title>Availability Form</mat-card-title>
            <mat-card-subtitle>Set your Availability</mat-card-subtitle>
        </mat-card-header>
        <div class="gap m-5"></div>
        <mat-card-content>
            @if(scheduleForm) {
            <form [formGroup]="scheduleForm" class="schedule-form-2">

                @if(isAdminUser() && mode === 'create') {
                <div class="p-12 date-section">
                    <div class="section-title g-just-flex gap-12" style="
                justify-content: space-between;
                    font-weight: 500; font-size: 1rem;
                    color: var(--mat-sys-primary)
                    ">
                        <span>Practitioner</span>
                    </div>
                    <div class="sub-section-wrapper" style="padding: 12px;">
                        <mat-form-field appearance="outline" style="width: 100%;">
                            <mat-label>Schedule is for</mat-label>
                            <mat-select [value]="selectedPractitionerReference"
                                (valueChange)="onPractitionerSelected($event)">
                                @for(practitioner of practitionerOptions; track practitioner.reference) {
                                <mat-option [value]="practitioner.reference">
                                    {{ practitioner.display }}
                                </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        @if(loadingPractitioners) {
                        <div class="small-subtitle" style="color: var(--mat-sys-on-surface)">
                            Loading practitioners...
                        </div>
                        } @else if(practitionerOptions.length === 0) {
                        <div class="small-subtitle" style="color: var(--mat-sys-on-surface)">
                            No practitioners found for this organization.
                        </div>
                        } @else {
                        <div class="small-subtitle" style="color: var(--mat-sys-on-surface)">
                            Creating schedule for {{ selectedPractitionerDisplay }}.
                        </div>
                        }
                    </div>
                </div>
                <mat-divider></mat-divider>
                }

                <div class="p-12 date-section">
                    <div class="section-title g-just-flex gap-12" style="
                justify-content: space-between;
                    font-weight: 500; font-size: 1rem;
                    color: var(--mat-sys-primary)
                    ">

                        <span>Date</span>
                        @if(subGroupsVisibility.date) {
                        <mat-icon (click)="subGroupsVisibility.date = false" class="small-icon">expand_less</mat-icon>
                        } @else {
                        <mat-icon (click)="subGroupsVisibility.date = true" class="small-icon">expand_more</mat-icon>
                        }
                    </div>
                    <div class="sub-section-wrapper" formGroupName="date" style="overflow: hidden;"
                        [style.height]="subGroupsVisibility.date ? 'auto' : '0px'"
                        [style.padding]="subGroupsVisibility.date ? '12px' : '0px'"
                        [style.transition]="'0.3s ease-in-out'" [style.transitionProperty]="'height'">
                        <div class="start-date-form mb-20">
                            <label for="startDate" class="mb-5" style="display: block;">Start Date</label>
                            <mat-form-field appearance="outline" style=" display: block;">
                                <input matInput [matDatepicker]="pickerSD" placeholder="01/30/2025"
                                    formControlName="start" [min]="todayMinDate">
                                <mat-hint>MM/DD/YYYY</mat-hint>
                                <mat-datepicker-toggle matIconSuffix [for]="pickerSD"></mat-datepicker-toggle>
                                <mat-datepicker #pickerSD></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="end-date-form" formGroupName="end">
                            <div class="form-group-label">End Date</div>
                            <mat-radio-group formControlName="type" class="radio-group ">
                                <div class="radio-with-options g-just-flex gap-12
                            justify-content-start
                            ">
                                    <!-- <mat-radio-button [value]="'specific_date'"
                                        style="margin-bottom: 20px;"></mat-radio-button> -->
                                    <mat-form-field appearance="outline" style="width: 100%;">
                                        <input matInput placeholder="01/30/2025" [matDatepicker]="pickerSDV"
                                            formControlName="value" [min]="endMinDate">
                                        <mat-hint>MM/DD/YYYY</mat-hint>
                                        <mat-datepicker-toggle matIconSuffix [for]="pickerSDV"></mat-datepicker-toggle>
                                        <mat-datepicker #pickerSDV></mat-datepicker>
                                    </mat-form-field>

                                    @if(planningHorizonConflictCheckFailed) {
                                    <div class="small-subtitle" style="color: var(--mat-sys-error); margin-top: -6px;">
                                        Could not verify schedule conflicts. Check connection.
                                    </div>
                                    }

                                    @if(hasPlanningHorizonConflict) {
                                    <div class="small-subtitle" style="color: var(--mat-sys-error); margin-top: -6px;">
                                        Planning horizon conflicts with {{planningHorizonConflictSchedules.length}}
                                        existing schedule(s).
                                    </div>
                                    }
                                </div>
                                <div class="gap m-3"></div>
                                <!-- <div class="radio-with-options g-just-flex gap-12 justify-content-start">

                                    <mat-radio-button [value]="'indefinite'" style="margin-bottom: 0px;">Indefinite Into
                                        the Future</mat-radio-button>
                                </div> -->





                            </mat-radio-group>
                        </div>

                    </div>



                </div>
                <mat-divider></mat-divider>

                <div class="p-12 date-section">
                    <div class="section-title g-just-flex gap-12" style="
                justify-content: space-between; max-width: 100%;
                box-sizing: border-box;
                    font-weight: 500; font-size: 1rem;
                    color: var(--mat-sys-primary)
                    ">

                        <div>
                            <div>Date Recurrence Pattern</div>
                            <span class="small-subtitle" style="color: var(--mat-sys-on-surface)">
                                Set available days between the chosen date range
                            </span>


                        </div>
                        @if(subGroupsVisibility.dateRecurrence) {
                        <mat-icon (click)="subGroupsVisibility.dateRecurrence = false" class="small-icon"
                            style="overflow: visible;">expand_less</mat-icon>
                        } @else {
                        <mat-icon (click)="subGroupsVisibility.dateRecurrence = true" class="small-icon"
                            style="overflow: visible;">expand_more</mat-icon>
                        }
                    </div>
                    <div class="sub-section-wrapper" formGroupName="dateRecurrence" style=" overflow: hidden;"
                        [style.height]="subGroupsVisibility.dateRecurrence ? 'auto' : '0px'"
                        [style.padding]="subGroupsVisibility.dateRecurrence ? '12px 0px' : '0px'"
                        [style.transition]="'0.3s ease-in-out'" [style.transitionProperty]="'height'">
                        <!-- <div class="start-date-form mb-20"> -->
                        <mat-radio-group formControlName="type" class="radio-group ">
                            <div class="radio-with-options g-just-flex
                            justify-content-start
                            ">
                                <mat-radio-button [value]="'mon_fri'" style="margin-bottom: 12px;">Monday -
                                    Friday</mat-radio-button>


                            </div>
                            <div class="gap"></div>
                            <div class="radio-with-options g-just-flex justify-content-start">

                                <mat-radio-button [value]="'all_days'" style="margin-bottom: 12px;">All
                                    Days</mat-radio-button>

                            </div>
                            <div class="radio-with-options g-just-flex justify-content-start">

                                <mat-radio-button [value]="'weekdays'">
                                    Some days of every week
                                </mat-radio-button>
                            </div>
                            @if(scheduleForm.get(['dateRecurrence', 'type'])?.value === "weekdays"){
                            <div class="weekdays-selection-wrapper">
                                <div class="section-subtitle my-12" style="font-size: 1rem;">
                                    Select Days
                                </div>
                                <mat-chip-listbox [multiple]="true"
                                    (change)="setValue($event, scheduleForm!.get(['dateRecurrence', 'value'])!)"
                                    class="chip-list">
                                    @for(option of ['Monday', "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday",
                                    "Sunday"]; track $index;){
                                    <mat-chip-option value="{{option}}">

                                        {{option}}
                                    </mat-chip-option>
                                    }



                                </mat-chip-listbox>
                            </div>
                            }






                        </mat-radio-group>
                        <!-- </div> -->


                    </div>



                </div>





                <mat-divider></mat-divider>

                <div class="p-12 date-section">
                    <div class="section-title g-just-flex gap-12" style="
                justify-content: space-between;
                    font-weight: 500; font-size: 1rem;
                    color: var(--mat-sys-primary)
                    ">

                        <span>Weekly Time Slots</span>
                        @if(subGroupsVisibility.time) {
                        <mat-icon (click)="subGroupsVisibility.time = false" class="small-icon">expand_less</mat-icon>
                        } @else {
                        <mat-icon (click)="subGroupsVisibility.time = true" class="small-icon">expand_more</mat-icon>
                        }
                    </div>

                    <div class="sub-section-wrapper" formGroupName="timePerWeekday" style="overflow: hidden;"
                        [style.height]="subGroupsVisibility.time ? 'auto' : '0px'"
                        [style.padding]="subGroupsVisibility.time ? '12px' : '0px'"
                        [style.transition]="'0.3s ease-in-out'" [style.transitionProperty]="'height'">

                        @if(selectedWeekdays.length === 0) {
                        <div class="small-subtitle" style="color: var(--mat-sys-on-surface)">
                            Select a recurrence pattern above to choose weekdays.
                        </div>
                        } @else {

                        @for(weekday of selectedWeekdays; track weekday){
                        <div class="mb-20"
                            style="border: 1px solid var(--mat-sys-outline-variant); border-radius: 10px; padding: 12px;">
                            <div class="g-just-flex" style="justify-content: space-between; align-items: center;">
                                <div style="font-weight: 600;">{{weekday}}</div>
                                <div class="g-just-flex gap-6">
                                    <button mat-icon-button type="button" (click)="openDayApplyDialog(weekday)"
                                        aria-label="Apply this day's slots to other days">
                                        <span class="material-symbols-outlined"
                                            style="font-size: 16px; height: 16px; line-height: 16px; width: 16px;">
                                            calendar_view_week
                                        </span>
                                    </button>
                                </div>
                            </div>

                            <div class="gap my-10"></div>

                            <div [formArrayName]="weekday">
                                @for(slotGroup of getSlotsArray(weekday).controls; track slotGroup; let index = $index){
                                <div class="g-just-flex gap-2" style="align-items: flex-start;
                                flex-direction: column; box-sizing: border-box;;
                                " [formGroupName]="$index">
                                    <div class="g-just-flex gap-6" style="width: 100%; align-items: flex-start;
                                    justify-content: space-between;
                                flex-direction: row; box-sizing: border-box;">
                                        <mat-form-field appearance="outline" style="flex: 1;" floatLabel="always">
                                            <mat-label>Start</mat-label>
                                            <input matInput formControlName="start" [matTimepicker]="startPicker"
                                                style="font-size: 14px;">
                                            <!-- <mat-timepicker-toggle matIconPrefix [for]="startPicker" /> -->
                                            <mat-timepicker #startPicker />
                                            @if(slotGroup.errors?.['timeRangeOrder']){
                                            <mat-error>Start must be before end</mat-error>
                                            }
                                            @if(slotGroup.errors?.['slotConflict']){
                                            <mat-error>Conflicts with another slot</mat-error>
                                            }
                                            @if(slotGroup.errors?.['splitInvalid']){
                                            <mat-error>Cannot split this slot evenly</mat-error>
                                            }
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" style="flex: 1;" floatLabel="always">
                                            <mat-label>End</mat-label>
                                            <input matInput formControlName="end" [matTimepicker]="endPicker"
                                                style="font-size: 14px;">
                                            <!-- <mat-timepicker-toggle matIconPrefix [for]="endPicker" /> -->
                                            <mat-timepicker #endPicker />
                                        </mat-form-field>
                                    </div>
                                    <div class="action-buttons-group mb-15 g-just-flex justify-content-end mx-4"
                                        style="    margin-top: -20px; width: 100%;">

                                        <button mat-icon-button type="button"
                                            (click)="addSlotAtNextIndex(weekday, index)" aria-label="Add slot">
                                            <span class="material-symbols-outlined"
                                                style="font-size: 16px; height: 16px; line-height: 16px; width: 16px;">
                                                add
                                            </span>

                                        </button>

                                        <button mat-icon-button type="button"
                                            [matMenuTriggerFor]="slotSplitMenu"
                                            (menuOpened)="setPendingSlotContext(weekday, index)"
                                            aria-label="Split slot evenly">
                                            <span class="material-symbols-outlined"
                                                style="font-size: 16px; height: 16px; line-height: 16px; width: 16px;">
                                                call_split
                                            </span>

                                        </button>

                                        <button mat-icon-button type="button"
                                            (click)="openSlotApplyDialog(weekday, index)"
                                            aria-label="Apply slot to other days">
                                            <span class="material-symbols-outlined"
                                                style="font-size: 16px; height: 16px; line-height: 16px; width: 16px;">
                                                calendar_add_on
                                            </span>

                                        </button>

                                        <button mat-icon-button type="button"
                                            (click)="removeSlotAtIndex(weekday, index)" aria-label="Remove slot">
                                            <span class="material-symbols-outlined"
                                                style="font-size: 16px; height: 16px; line-height: 16px; width: 16px;">
                                                delete
                                            </span>

                                        </button>
                                    </div>


                                </div>

                                @if(getSlotsArray(weekday).errors?.['overlappingTimeRanges']){
                                <div class="small-subtitle" style="color: var(--mat-sys-error); margin-top: -6px;">
                                    Slots overlap within {{weekday}}.
                                </div>
                                }
                                }
                            </div>
                        </div>
                        }
                        }

                    </div>

                </div>

                <!-- Form fields for schedule creation go here -->
            </form>



            }
        </mat-card-content>
        <div class="abs-pos py-6 px-12 g-just-flex gap-15" style="justify-content: flex-end;">
            <button mat-button> Cancel</button>
            <button mat-flat-button type="button" (click)="save()"> Save</button>
        </div>
    </mat-card>

    <mat-card class="preview-schedule" style="    height: max-content;
    flex: 1 1 min-content;
    width: max-content;
    max-width: max-content;">
        <mat-card-header>
            <mat-card-title>
                Preview Your Schedule
            </mat-card-title>
            <mat-card-subtitle>
                Preview your schedule display on the bookings page
            </mat-card-subtitle>
        </mat-card-header>
        <div class="gap my-10"></div>
        <mat-card-content>
            <div class="preview-cards-wrapper 
            g-just-flex  flex-wrap  px-20" style="


                gap: 50px;
                
                align-items: flex-start">
                <div class="calendar-preview">
                    <!-- <mat-form-field appearance="outline" style=" display: block;"> -->

                    <!-- <input matInput [matDatepicker]="previewSD" placeholder="01/30/2025"
                        [value]="scheduleForm?.get(['date', 'start'])?.value" style="height: 0px;">
                    <mat-hint>MM/DD/YYYY</mat-hint> -->
                    <!-- <mat-datepicker-toggle matIconSuffix [for]="pickerSD"></mat-datepicker-toggle> -->

                    <mat-calendar #previewSD style="width: 280px; max-width: 100%;" [selected]="selectedPreviewDate"
                        [dateClass]="previewDateClass" (selectedChange)="onPreviewDateSelected($event)"></mat-calendar>
                    <!-- </mat-form-field> -->
                </div>
                <div class="time-preview" style="flex: 1 0 275px; max-width: 100%;">
                    <div class="time-preview-title mb-20" style="text-align: center;">
                        @if(selectedPreviewDate){
                        Slots for {{selectedPreviewDate | date: 'mediumDate'}}
                        } @else {
                        Select a date on calendar to view slots
                        }
                    </div>

                    @if(filteredPreviewSlots.length > 0){
                    <div class="small-subtitle" style="text-align: center; color: var(--mat-sys-on-surface)">
                        Total: {{filteredPreviewSlots.length}}
                    </div>
                    <div class="gap my-10"></div>
                    <div class="time-wrapper g-just-flex gap-12 flex-wrap">
                        @for(slot of filteredPreviewSlots; track $index;){
                        <div class="time-sl" style="font-size: 0.85rem;">
                            {{slot.dateTimeStart | date:'shortTime'}} - {{slot.dateTimeEnd | date:'shortTime'}}
                        </div>
                        }
                    </div>

                    }@else {
                    @if(selectedPreviewDate) {
                    <div style="text-align: center; color: var(--mat-sys-on-surface)"> No slots for this date</div>
                    }
                    }
                </div>

            </div>

        </mat-card-content>

    </mat-card>

</div>

<mat-menu #slotSplitMenu="matMenu">
    @for(duration of slotSplitDurations; track duration){
    <button mat-menu-item type="button" (click)="handleSplitSelection(duration)">
        Split into {{duration}} min blocks
    </button>
    }
</mat-menu>
